import React, { useEffect } from 'react';
import { lifenomeLogoGreeting } from 'on_web/assets/imageList';
import backgroundImg from 'on_web/assets/images/general-welcome-background.svg';

import ContainerWithBackground from 'on_web/components/shared/Common/ContainerWithBackgroundImg';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, AppBar, Toolbar } from '@material-ui/core';
import Button from 'on_web/components/shared/Common/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import auth0Client from 'on_web/Auth0';

function LoginPage(props) {
  const { t } = useTranslation();
  const useStyles = makeStyles(theme => ({
    root: {
      top: 'auto',
      bottom: 0,
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    if (window.location.href.indexOf('loggedOut') > -1) {
      auth0Client.signIn();
    } else {
      const timer = setTimeout(() => {
        auth0Client.signIn();
      }, 3000);

      return () => {
        clearTimeout(timer);
      };
    }
  });
  return (
    <div>
      <ContainerWithBackground
        image={backgroundImg}
        maxWidth={'957px'}
        maxHeight={'830px'}
        height={'90vh'}
        width={'100vw'}
        marginTop={'0vh'}
      >
        <Box
          color="#ffffff"
          maxWidth="350px"
          position="relative"
          pr={{ xs: 2 }}
          pl={{ xs: 2 }}
          left={{ sm: '27%' }}
          top={{ sm: '10%', xs: '30%' }}
        >
          <img
            src={lifenomeLogoGreeting}
            alt="Lifenome logo"
            style={{
              marginLeft: '10%',
              marginBottom: '30px',
              width: '103px',
              height: '88px',
            }}
          />
          <Typography variant="h6" style={{ marginLeft: '10%' }}>
            {t('onboarding.introSection.login.title')}
          </Typography>
        </Box>
      </ContainerWithBackground>
      {/* Login and Sign up replaced with auto login function */}
      {/* <AppBar
        position="fixed"
        color="transparent"
        classes={{ ...classes }}
        elevation={0}
      >
        <Toolbar>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Box display="flex" justifyContent="flex-end">
                <Button
                  fullWidth
                  maxWidth="330px"
                  variant="outlined"
                  height={46}
                  onClick={() => {}}
                  style={{
                    backgroundColor: '#ffffff',
                  }}
                >
                  {t('onboarding.introSection.login.register')}
                </Button>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box display="flex" justifyContent="flex-start">
                <Button
                  fullWidth
                  maxWidth="330px"
                  height={46}
                  backgroundGradient={
                    'linear-gradient(to right, #194378, #30eaff)'
                  }
                  onClick={auth0Client.signIn}
                >
                  {t('onboarding.introSection.login.signing')}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar> */}
    </div>
  );
}

export default LoginPage;
